export const HOLDING_FRAGMENT = `
  fragment holdingFields on Holding {
    companyId
    isAnalysisRestricted
  }
`;

export const PORTFOLIOS_FRAGMENT = `
  fragment portfolioFields on Portfolio {
    id
    name
    createdAt
    currencyISO
    updatedAt
    type
    manualInputOption
    isAnalysisRestricted
    link {
      brokerageName
    }
    holdings {
      ...holdingFields
    }
  }
  ${HOLDING_FRAGMENT}
`;
